import { getBody, server } from '@lib/api/http';
import { queryKeys } from '@lib/api/queryKeys';
import { useSession } from '@lib/auth/session';
import { useQuery } from '@tanstack/react-query';

export const useDashboardQuery = () => {
  const loggedIn = useSession();
  return useQuery<any>({
    queryKey: queryKeys.dashboard,
    queryFn: () => getBody(`${server}v1/dashboards/get-dashboard-stats`),
    enabled: loggedIn,
  });
};
